/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const MBoxIcon = ({ width = 24, height = 24, hidden = false, title = 'MBox' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M33 4H3a1 1 0 0 0-1 1v26a1 1 0 0 0 1 1h30a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1Zm-1 26H4V10h28Z"
    />
    <path
      d="M6 12h2v2H6zM6 22h2v2H6zM10 12h4v2h-4zM16 12h4v2h-4zM22 12h4v2h-4zM10 26h4v2h-4zM16 26h4v2h-4zM22 26h4v2h-4zM28 12h2v2h-2zM28 16h2v2h-2zM6 16h2v4H6zM28 20h2v4h-2zM6 26h2v2H6zM28 26h2v2h-2z"
    />
  </svg>`;
};
